import Home from './views/Home.vue'
import AllMessage from './views/AllMessage.vue'
import UnreadMessage from './views/UnreadMessage.vue'
import ReadedMessage from './views/ReadedMessage.vue'
import MessageDetail from './views/MessageDetail.vue'
import BalanceWarn from './views/BalanceWarn.vue'

let routes = [
    {
        path: '/',
        redirect: '/allMessage',
        hidden: true
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-bar-chart', //图标样式class
        children: [
            { path: '/allMessage', component: AllMessage, name: 'AllMessage'},  //全部消息
            { path: '/unreadMessage', component: UnreadMessage, name: 'UnreadMessage'},  //未读消息
            { path: '/readedMessage', component: ReadedMessage, name: 'ReadedMessage'},  //已读消息          
            { path: '/messageDetail', component: MessageDetail, name: 'MessageDetail'},  //公告消息
            { path: '/balanceWarn', component: BalanceWarn, name: 'BalanceWarn'},  //余额提醒
        ]
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js